// South African banks with their universal branch codes. In SA each bank has a
// single universal branch code that works for all accounts, so picking the bank
// fills the branch code automatically — removing the most error-prone field.
// "Other" lets the user enter a bank + branch code manually.

export interface SaBank {
  name: string;
  branchCode: string;
}

export const SA_BANKS: SaBank[] = [
  { name: 'Absa Bank', branchCode: '632005' },
  { name: 'African Bank', branchCode: '430000' },
  { name: 'Bank Zero', branchCode: '888000' },
  { name: 'Bidvest Bank', branchCode: '462005' },
  { name: 'Capitec Bank', branchCode: '470010' },
  { name: 'Discovery Bank', branchCode: '679000' },
  { name: 'First National Bank (FNB)', branchCode: '250655' },
  { name: 'Investec Bank', branchCode: '580105' },
  { name: 'Mercantile Bank', branchCode: '450905' },
  { name: 'Nedbank', branchCode: '198765' },
  { name: 'Sasfin Bank', branchCode: '683000' },
  { name: 'Standard Bank', branchCode: '051001' },
  { name: 'TymeBank', branchCode: '678910' },
];

export const OTHER_BANK = 'Other';

export const ACCOUNT_TYPES: { value: string; label: string }[] = [
  { value: 'cheque', label: 'Cheque / Current' },
  { value: 'savings', label: 'Savings' },
  { value: 'transmission', label: 'Transmission' },
];

export function branchCodeFor(bankName: string): string | null {
  const match = SA_BANKS.find((b) => b.name === bankName);
  return match ? match.branchCode : null;
}
